import React, { useState } from "react";
import { getAuth, sendEmailVerification } from "firebase/auth";
import { Button, Alert, Box, Typography } from "@mui/material";

const VerifyEmailPage = () => {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleResend = async () => {
    setError("");
    const auth = getAuth();
    const user = auth.currentUser;
    if (user && !user.emailVerified) {
      try {
        await sendEmailVerification(user);
        setSent(true);
      } catch (e) {
        setError("Errore durante l'invio dell'email. Riprova tra qualche secondo.");
      }
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: "auto", mt: 8, p: 3, bgcolor: "#fff", borderRadius: 2, boxShadow: 2 }}>
      <Typography variant="h5" gutterBottom>
        Verifica la tua email
      </Typography>
      <Typography sx={{ mb: 2 }}>
        Per continuare devi confermare il tuo indirizzo email.  
        Controlla la posta in arrivo e clicca sul link di verifica.
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {sent && <Alert severity="success" sx={{ mb: 2 }}>Email inviata! Controlla la posta.</Alert>}
      <Button
        onClick={handleResend}
        variant="contained"
        color="primary"
        fullWidth
        disabled={sent}
      >
        Invia nuovamente l'email di verifica
      </Button>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Dopo aver verificato la tua email, aggiorna questa pagina per continuare.
      </Typography>
    </Box>
  );
};

export default VerifyEmailPage;
